import { render, staticRenderFns } from "./PaymentTranzila.vue?vue&type=template&id=053dd56c&"
import script from "./PaymentTranzila.vue?vue&type=script&lang=js&"
export * from "./PaymentTranzila.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports